import { render, staticRenderFns } from "./ReturnedReport.vue?vue&type=template&id=0c23399a&scoped=true"
import script from "./ReturnedReport.vue?vue&type=script&lang=js"
export * from "./ReturnedReport.vue?vue&type=script&lang=js"
import style0 from "./ReturnedReport.vue?vue&type=style&index=0&id=0c23399a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c23399a",
  null
  
)

export default component.exports